/*
 * このソースコードはblanco Frameworkによって作成されました。
 */
import {
  RuleParamSchema,
  ValidationMessageTemplate,
  ValidationRuleFunction,
  ValidationRuleSchema,
} from "vee-validate/dist/types/types"

import { groupNameDuplicateValidator } from "./groupNameDuplicateValidator"
import { customMessage } from "./validatorUtil"

/**
 * VeeValidateのValidateRuleSchemaの実装クラスです。
 *
 * カスタムルール groupNameDuplicate の定義です。
 */
export class GroupNameDuplicateRuleSchema implements ValidationRuleSchema {
  validate: ValidationRuleFunction = (value, params) => {
    return groupNameDuplicateValidator(value, params)
  }
  params: RuleParamSchema[] = ["groupNameList", "errorMessage"]
  message: ValidationMessageTemplate = (field: string, params?: Record<string, any>) => {
    return customMessage(field, params, ["groupNameList", "errorMessage"])
  }
}
